import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IEmailPlansSlice {
  selectedEmailPlanId: number | null;
  showEmailPricingTierDialog: boolean;
}

export const createEmailPlansSliceDefaultValues = (): IEmailPlansSlice => ({
  selectedEmailPlanId: null,
  showEmailPricingTierDialog: false,
});

export const createEmailPlansSlice: StateCreator<IEmailPlansSlice> = () => createEmailPlansSliceDefaultValues();

export type EmailPlansPageStore = UseBoundStore<StoreApi<IEmailPlansSlice>>;

export const createEmailPlansHooks = (pageStore: EmailPlansPageStore) => {
  return {
    useIsShowingEmailPricingTierDialog: () => pageStore((state) => state.showEmailPricingTierDialog),
    useSelectedEmailPlanId: () => pageStore((state) => state.selectedEmailPlanId),
  };
};

export type EmailPlansHooks = ReturnType<typeof createEmailPlansHooks>;
